import { render, staticRenderFns } from "./pogs-patient-preview--obstetric-history.vue?vue&type=template&id=560a095b&"
import script from "./pogs-patient-preview--obstetric-history.vue?vue&type=script&lang=js&"
export * from "./pogs-patient-preview--obstetric-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports